import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button,
  Timespanpicker
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import {Timepicker} from 'react-timepicker';
import 'react-timepicker/timepicker.css';
import { faThemeisle } from "@fortawesome/free-brands-svg-icons";
import { Table, Tag, Drawer, Button as AntButton, Select } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  InfoCircleOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import { DatePicker, Modal, TimePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { ExclamationCircleFilled, DownloadOutlined } from '@ant-design/icons';
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;
const dateFormat = "DD/MM/YYYY";
const weekFormat = "w: MMMM YYYY";
const customFormat = (value) => `Semana ${value.format(weekFormat)}`;

const { confirm } = Modal;
const showDeleteConfirm = (hourRange, ctx) => {
  confirm({
    title: '¿Seguro que lo quieres eliminar?',
    icon: <ExclamationCircleFilled />,
    content: 'Esta acción no se podrá deshacer',
    okText: 'Sí',
    okType: 'danger',
    cancelText: 'No',
    onOk() {
      console.log('OK');
      ctx.deleteHourRange(hourRange);
    },
    onCancel() {
      console.log('Cancel');
    },
  });
};
const listSort = [
  {
    label: "Antiguos primero",
    value: "ASC"
  },
  {
    label: "Nuevos primero",
    value: "DESC"
  }
];


// import TextField from '@mui/material/TextField';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';

class CheckinListAll extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    let myCompany = null;
    if (this.props.myCompany) {
      myCompany = this.props.myCompany;
    } else {
      myCompany = (this.props.mainState && this.props.mainState.myCompany) ? this.props.mainState.myCompany : null;
    }

    const now = dayjs();
    const startOfWeek = now.startOf('week'); // Monday 00:00:00
    const endOfWeek = now.endOf('week').subtract(1, 'second'); // Sunday 23:59:59
    let filterRange = [startOfWeek, endOfWeek];
    this.state = {
      myCompany: myCompany,
      // myCheckers: myCheckers,
      checkins: [],
      // myEmployees: myEmployees,
      servicesSize: "auto",
      pagination: { pageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40'] },
      openDetails: null,
      lastCheckins: [],
      filterRange: filterRange,
      listSort: listSort[0].value
    };

    this.loadCheckins = this.loadCheckins.bind(this);
    this.downloadCheckins = this.downloadCheckins.bind(this);
    this.buildCheckins = this.buildCheckins.bind(this);
    this.getDrawer = this.getDrawer.bind(this);
    this.onCloseDrawer = this.onCloseDrawer.bind(this);
  }
  componentDidMount() {
    this.loadCheckins();
    // this.loadMyEmployees();
  }
  componentWillUnmount() {
    if (this.updateCheckins) clearInterval(this.updateCheckins);
    if (this.reloadCheckins) clearInterval(this.reloadCheckins);
    // this.props.saveMyCompany(this.state.myCompany);
    // this.props.saveMyCompanyWorkplaces(this.state.myCheckers);
    // this.props.saveMyEmployees(this.state.myEmployees);
    // this.props.saveMyCheckers(this.state.myCheckers);
  }
  async loadCheckins(company_id, range) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    console.log("load checkins (range)", range);
    this.setState({ isLoadingCheckins: true });
    const now = moment();
    const startOfWeek = now.clone().startOf('week').startOf('day').unix();
    const endOfWeek = now.clone().endOf('week').endOf('day').unix();
    let start = startOfWeek;
    let end = endOfWeek;
    if (range) {
      start = range[0].unix();
      end = range[1].unix();
    }
    if (!range && this.state.filterRange) {
      start = this.state.filterRange[0].unix();
      end = this.state.filterRange[1].unix();
    }
    console.log("load checkins", this.state);
    let filter = {
      id: company_id,
      filter: {
        start: start,
        end: end,
        sort: this.state.listSort
      }
    };
    this.props.loadCheckins(filter).then(result => {
      this.setState({
        isLoadingCheckins: false
      });
      if (result.ok) {
        let checkins = [];
        let employees = [];
        if (result.ok) {
          Object.values(result.employees).map(employee => {employees[employee.uuid] = employee; });
          checkins = Object.values(result.checkins);
        }
        this.setState({
          checkins: checkins,
          employees: employees,
        });
        if (!this.updateCheckins) this.updateCheckins = setInterval(this.updateElapsedTime, 1000);
        // if (!this.reloadCheckins) this.reloadCheckins = setInterval(this.loadCheckins, 10000);
      }
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar los fichajes: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadLastCheckins(employee_uuid) {
    let company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingLastCheckins: true });
    this.props.loadLastCheckins(company_id, employee_uuid).then(result => {
      this.setState({
        isLoadingLastCheckins: false
      });
      if (result.ok) {
        let lastCheckins = this.state.lastCheckins;
        if (!lastCheckins) lastCheckins = [];
        lastCheckins[employee_uuid] = result.checkins[employee_uuid];
        this.setState({
          lastCheckins: lastCheckins
        });
      }
    })
    .catch((error) => {
      this.setState({
        isLoadingLastCheckins: false
      });
      // Error 😨
      console.log("Error al cargar los fichajes: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async downloadCheckins(company_id, range) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    console.log("load checkins (range)", range);
    this.setState({ isDownloadingCheckins: true });
    const now = moment();
    const startOfWeek = now.clone().startOf('week').startOf('day').unix();
    const endOfWeek = now.clone().endOf('week').endOf('day').unix();
    let start = startOfWeek;
    let end = endOfWeek;
    if (range) {
      start = range[0].unix();
      end = range[1].unix();
    }
    if (!range && this.state.filterRange) {
      start = this.state.filterRange[0].unix();
      end = this.state.filterRange[1].unix();
    }
    console.log("download checkins", this.state);
    let filter = {
      id: company_id,
      filter: {
        start: start,
        end: end,
        sort: this.state.listSort
      }
    };
    this.props.downloadCheckins(filter).then(response => {
        this.setState({
          isDownloadingCheckins: false
        });

        const csvBlob = new Blob([response.data], { type: "text/csv" });
        // Obtener el nombre de archivo del encabezado Content-Disposition
        const contentDisposition = response.headers['content-disposition'];
        const match = contentDisposition.match(/filename="(.+)"/);
        const fileName = match && match[1] ? match[1] : 'data.csv';

        const url = window.URL.createObjectURL(csvBlob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
    .catch((error) => {
      this.setState({
        isDownloadingCheckins: false
      });
      // Error 😨
      console.log("Error al descargar los fichajes: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  updateElapsedTime = () => {
    // console.log("Update Elapsed Time");
    const { checkins } = this.state;
    this.setState({ checkins: checkins });
    // const _checkins = checkins.map((checkin, index) => {
    //   if (checkin.active) {
    //     let elapsed = moment().diff(moment.unix(checkin.start), 'hours') + "h "
    //     + moment().diff(moment.unix(checkin.start), 'minutes') % 60 + "m "
    //     + moment().diff(moment.unix(checkin.start), 'seconds') % 60 + "s";
    //     checkin.elapsed = elapsed;
    //   }
    //   return checkin;
    // });
    // this.setState({ checkins: _checkins });
  };
  handleMyCompanyFieldChange(field, value) {
    this.handleEntityFieldChange("myCompany", field, value);
    // let myCompany = this.state.myCompany;
    // if (!myCompany) myCompany = {};
    // myCompany[field] = value;
    // this.setState({ myCompany: myCompany });
  }
  handleNewCheckerFieldChange(field, value) {
    this.handleEntityFieldChange("newChecker", field, value);
    // let newChecker = this.state.newChecker;
    // if (!newChecker) newChecker = {};
    // newChecker[field] = value;
    // this.setState({ newChecker: newChecker });
  }
  handleEntityFieldChange(entity_name, field, value) {
    let entity = this.state[entity_name];
    if (!entity) entity = {};
    entity[field] = value;
    this.setState({ [entity_name]: entity });
  }
  handleTableChange = pagination => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        ...pagination
      }
    });
  };
  cleanCheckins(checkins) {
    const { employees } = this.state;
    // console.log("checkins", checkins);
    return checkins.map((checkin, index) => {
      // Calcular el tiempo transcurrido desde 'start'
      let employee = employees[checkin.employee];
      const active = parseInt(checkin.status_id) === 404;
      const start = parseInt(checkin.start);
      const finish = checkin.finish ? parseInt(checkin.finish) : null;
      const dateStart = moment.unix(start).format('DD/MM/YYYY HH:mm:ss');
      const dateEnd = finish ? moment.unix(finish).format('DD/MM/YYYY HH:mm:ss') : null;
      let total = finish ? finish - start : null;
      let elapsed = null;
      let status = null;
      if (!finish) {
        elapsed = moment().diff(moment.unix(start), 'hours') + "h "
        + moment().diff(moment.unix(start), 'minutes') % 60 + "m "
        + moment().diff(moment.unix(start), 'seconds') % 60 + "s";
        status = parseInt(checkin.status_id);
      }
      if (total) {
        total = Math.floor(total / 3600) + "h " + Math.floor(total % 3600 / 60) + "m"
      }

      return {
        key: checkin.id,
        id: checkin.id,
        employee: employee.uuid,
        name: employee.name + " " + employee.surname1,
        // email: item.employee.email,
        // mobile: item.employee.mobile,
        start: start, // mostrar el tiempo transcurrido
        elapsed: elapsed, // mostrar el tiempo transcurrido
        status: status,
        active: active,
        total: total,
        dateStart: dateStart,
        dateEnd: dateEnd
      };
    });
  }
  cleanLastCheckins(checkins) {
    return checkins.map((checkin, index) => {
      // Calcular el tiempo transcurrido desde 'start'
      const active = parseInt(checkin.status_id) === 404;
      const start = parseInt(checkin.start);
      const finish = checkin.finish ? parseInt(checkin.finish) : null;
      const dateStart = moment.unix(start).format('DD/MM/YYYY HH:mm:ss');
      const dateEnd = finish ? moment.unix(finish).format('DD/MM/YYYY HH:mm:ss') : null;
      let total = finish ? finish - start : null;
      let elapsed = null;
      let status = null;
      if (!finish) {
        elapsed = moment().diff(moment.unix(start), 'hours') + "h "
        + moment().diff(moment.unix(start), 'minutes') % 60 + "m "
        + moment().diff(moment.unix(start), 'seconds') % 60 + "s";
        status = parseInt(checkin.status_id);
      }
      if (total) {
        total = Math.floor(total / 3600) + "h " + Math.floor(total % 3600 / 60) + "m"
      }

      return {
        key: checkin.id,
        id: checkin.id,
        // name: item.employee.name + " " + item.employee.surname1,
        // email: item.employee.email,
        // mobile: item.employee.mobile,
        start: start, // mostrar el tiempo transcurrido
        elapsed: elapsed, // mostrar el tiempo transcurrido
        status: status,
        active: active,
        total: total,
        dateStart: dateStart,
        dateEnd: dateEnd
      };
    });
  }
  buildCheckins() {
    const { pagination } = this.state;
    const columns = [
      // {
      //   title: 'ID',
      //   dataIndex: 'id',
      //   key: 'id',
      // },
      {
        title: 'Estado',
        dataIndex: 'status',
        key: 'status',
        render: (_, record) => 
          (record.active || (record.total && record.total !== 0)) ? 
            (record.active ? 
              <Tag icon={<LoadingOutlined />} color="processing">{record.elapsed}</Tag> 
              :
              <Tag icon={<CheckCircleOutlined />} color="green">{record.total}</Tag>) 
            :
            <Tag icon={<MinusCircleOutlined />} color="red">Inactivo</Tag>
      },
      // {
      //   title: 'Tiempo',
      //   dataIndex: 'elapsed',
      //   key: 'elapsed',
      // },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Inicio',
        dataIndex: 'dateStart',
        key: 'dateStart',
      },
      {
        title: 'Fin',
        dataIndex: 'dateEnd',
        key: 'dateEnd',
      },
      {
        title: 'Acciones',
        dataIndex: 'actions',
        key: 'actions',
        render: (_, record) => <AntButton type="primary" icon={<InfoCircleOutlined />} onClick={() => {
          console.log("record",record);
          this.setState({ openDetails: record.employee });
          this.loadLastCheckins(record.employee);
        }}>Detalles</AntButton>
      }
    ];
    let checkins = this.state.checkins;
    checkins = this.cleanCheckins(checkins);
    // console.log("checkins", checkins);
    let content = null;
    if (this.state.isLoadingCheckins && !checkins) {
      content = (
        <Col xs={12} md={12}>
          <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
        </Col>
      );
    } else {
      content = <Table columns={columns} dataSource={checkins} pagination={pagination} onChange={this.handleTableChange} />;
    }
    let card = (
      <Col xs={12}>
        <Card className="my-company-workplaces-info card-stats plain">
          <CardHeader>
            <b>
              <i className="fa fa-building" /> Lista de fichajes
            </b>
          </CardHeader>
          <CardBody>{content}</CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  onCloseDrawer() {
    this.setState({ openDetails: null });
  }
  getDrawer() {
    const { openDetails, lastCheckins } = this.state;
    // console.log("getDrawer", openDetails, lastCheckins);
    if (openDetails) {
      let employee = this.state.employees[openDetails];
      return {
        options: {
          open: true,
          title: "Últimos fichajes de " + employee.name + " " + employee.surname1 + " " + employee.surname2
        },
        content: this.buildLastCheckinsContent(lastCheckins ? lastCheckins[openDetails] : null)
      };
    } else {
      return { options: { open: false } };
    }
  }
  buildLastCheckinsContent(checkins) {
    if (!checkins) return <div></div>;
    checkins = checkins.checkins;
    if (checkins.count > 0) {
      checkins = checkins.list;
      checkins = this.cleanLastCheckins(checkins);
      const { pagination } = this.state;
      const columns = [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   key: 'id',
        // },
        {
          title: 'Estado',
          dataIndex: 'status',
          key: 'status',
          render: (_, record) => 
            (record.active || (record.total && record.total !== 0)) ? 
              (record.active ? 
                <Tag icon={<LoadingOutlined />} color="processing">{record.elapsed}</Tag> 
                :
                <Tag icon={<CheckCircleOutlined />} color="green">{record.total}</Tag>) 
              :
              <Tag icon={<MinusCircleOutlined />} color="red">Inactivo</Tag>
        },
        // {
        //   title: 'Tiempo',
        //   dataIndex: 'elapsed',
        //   key: 'elapsed',
        // },
        {
          title: 'Inicio',
          dataIndex: 'dateStart',
          key: 'dateStart',
        },
        {
          title: 'Fin',
          dataIndex: 'dateEnd',
          key: 'dateEnd',
        },
        // {
        //   title: 'Acciones',
        //   dataIndex: 'actions',
        //   key: 'actions',
        //   render: (_, record) => <AntButton type="primary" icon={<InfoCircleOutlined />} onClick={() => {
        //     this.setState({ openDetails: record.uuid });
        //     this.loadLastCheckins(record.uuid);
        //   }}>Detalles</AntButton>
        // }
      ];
      return (
        <Table
          columns={columns}
          dataSource={checkins}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
      );
    }
  }
  render() {
    let drawer = this.getDrawer();
    // console.log("this.state", this.state);
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={this.createMyCompanyCard()}
        />
        <div className="content">
          <Drawer
            {...drawer.options}
            closable={true}
            onClose={this.onCloseDrawer}
            key={"drawer-checkin-details"}
            placement={"bottom"}
          >
            {drawer.content}
          </Drawer>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <RangePicker
                        onChange={value => {
                          this.setState({ filterRange: value }, () =>
                            this.loadCheckins()
                          );
                        }}
                        status={this.state.filterRange ? null : "error"}
                        format={dateFormat}
                        value={this.state.filterRange}
                        defaultOpenValue={dayjs()}
                        size="large"
                        style={{ width: "100%" }}
                        disabled={this.state.isLoadingCheckins}
                      />
                    </Col>
                    <Col>
                      <Select
                        // mode="multiple"
                        allowClear
                        style={{
                          width: "100%"
                        }}
                        loading={this.state.isLoadingCheckins}
                        placeholder="Elige el orden"
                        value={this.state.listSort}
                        // defaultValue={['a10', 'c12']}
                        onChange={value => {
                          this.setState({ listSort: value }, () =>
                            this.loadCheckins()
                          );
                        }}
                        options={listSort}
                        suffixIcon={<i className="now-ui-icons design_bullet-list-67" />}
                        size="large"
                        disabled={this.state.isLoadingCheckins}
                      />
                    </Col>
                    <Col>
                      <AntButton type="primary" onClick={() => this.downloadCheckins()}  icon={<DownloadOutlined />}>
                        Descargar CSV
                      </AntButton>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            {/* {this.createMyCompanyCard()} */}
            {this.buildCheckins()}
          </Row>
        </div>
      </div>
    );
  }
}

export default CheckinListAll;



// WEBPACK FOOTER //
// ./src/views/CheckIn/CheckinListAll.jsx